"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapReservationPaymentStatusToItem = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const reservationPaymentStatusLabels = {
    unpaid: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/InvoiceOverview:IsUnpaidOnly', defaultMessage: 'Unpaid only' })),
    paid: 'Unexpected status',
};
const mapReservationPaymentStatusToItem = (value) => ({
    value,
    label: reservationPaymentStatusLabels[value],
});
exports.mapReservationPaymentStatusToItem = mapReservationPaymentStatusToItem;
//# sourceMappingURL=utils.js.map